import React from "react";

export default function ThemeToggle({ darkMode, setDarkMode }) {
  return (
    <div className="toggle-container">
      <span style={{ fontWeight: 600 }}>
        {darkMode ? "🌙 Dark Mode" : "☀️ Light Mode"}
      </span>
      <label className="switch">
        <input
          type="checkbox"
          checked={darkMode}
          onChange={() => setDarkMode(!darkMode)}
        />
        <span className="slider round"></span>
      </label>

      <style>
        {`
        .switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 24px;
        }
        .switch input {display:none;}
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 18px; width: 18px;
          left: 3px; bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: #00c853;
        }
        input:checked + .slider:before {
          transform: translateX(26px);
        }
      `}
      </style>
    </div>
  );
}
